import { render, staticRenderFns } from "./JdsForm.vue?vue&type=template&id=035f75da&scoped=true&"
import script from "./JdsForm.vue?vue&type=script&lang=ts&"
export * from "./JdsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035f75da",
  null
  
)

export default component.exports